import React from 'react';
import classNames from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';

import s from './TextRenderer.scss';

export interface ITextData {
	segments: string[];
	boldKeys?: number[];
	italicKeys?: number[];
	color?: 'purple' | 'green';
	links?: Record<number, string>;
	secondary?: boolean;
	size?: 'small' | 'medium' | 'big' | 'extrabig'
	onlyDesktop?: boolean;
	onlyMobile?: boolean;
}

export function TextRenderer({
	segments,
	boldKeys,
	italicKeys,
	color,
	links,
	secondary,
	size = 'small',
	onlyDesktop,
	onlyMobile,
}: ITextData) {
	useStyles(s);

	const renderSegment = (segment: string, key: number): JSX.Element => {
		if (links && Object.keys(links)?.map(Number).includes(key)) {
			return (
				<a href={links[key]} key={key} target="_blank" className="sl-text link">{segment}</a>
			);
		}
		return (
			<span
				key={key}
				className={classNames('sl-text', size, color, {
					bold: boldKeys?.includes(key),
					italic: italicKeys?.includes(key),
					secondary,
					'only-desktop': onlyDesktop,
					'only-mobile': onlyMobile,
				})}
			>
				{segment}
			</span>
		);
	};

	return (
		<>
			{segments.map(renderSegment)}
		</>
	);
}
